import * as React from 'react';
import { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector,
} from 'react-redux';


import Modal from 'antd/lib/modal';

import { useCtx } from 'one-ui-provider';
import { Skeleton } from 'one-model-local';
import Steps from 'antd/lib/steps';
import Tabs from "antd/lib/tabs";
import Button from "antd/lib/button";
import Badge from "antd/lib/badge";
import Table from "antd/lib/table";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Select from 'antd/lib/select';

import SearchIco from 'one-ui-svg/svg/search.svg';
import phonevalidate from "one-ui-svg/svg/phonevalidate.svg";

import {
    Value,
    Values,
} from 'one-ui-values';

import {
    selectAction,
} from 'one-state-source-local';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';

import {
    setSelectedAction,
} from 'one-state-subject/src/actions';


export const VerifyFlow = (
) => {
    const dispatch = useDispatch();
    const choosecaller = useSelector((state: any) => (state.choosecaller));
    const patients = useSelector((state: any) => (state.subjectstore));
    const source = useSelector((state: any) => (state.sources));
    const skeleton = useSelector((state: any) => (state.skeleton));
    const [steps, setStep] = useState(0);
    const [tabs, setTabs] = useState("1");
    const [sourectab, setSourceTab] = useState(false);
    const [mappingpage,setMappingPage] = useState(false);
    const [relation,setRelation] = useState("Type  Relation");
    const [sbutton,setSButton]=useState(false);
    const { resolver } = useCtx();

    const {
        Option,
    } = Select;

    const { Step } = Steps;
    const { TabPane } = Tabs;

    const subjects = patients.values;
    const sourcedata = source.values;

    // clear the selection on call reset
    useEffect(() => {
        if (choosecaller.start) {
            setStep(0);
            setTabs("1");
            setSourceTab(false);
            setRelation("Type Relation");
            setMappingPage(false);
            setSButton(false);
        } else {
            setTabs("2");
            setMappingPage(false);
            setSButton(false);
        }
    }, [choosecaller]);


    //Build values for the Source table
    let sourcemodaldata: any = [];
    let sourcepatientmodaldata :any=[];
    let sourcecolumn: any = [];

      //Build Values for the Patient Table
      let patientmodaldata: any = [];
      let column: any = [];

    if (sourcedata?.length > 0) {
        sourcedata.forEach((data: any) => {
            const info = {
                name: data.firstname ? data.firstname : "",
                dept: data.subtypename ? data.subtypename : "",
                loc: data.address ? data.address : "",
                id: data?.id,
                key:data?.id
            }
            if(data?.typename === "Provider") {
                sourcemodaldata.push(info);
            }
            if(data?.typename === "Patient") {
                sourcepatientmodaldata.push(info);
            }
        })
    }

    sourcecolumn = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Persona",
            dataIndex: "dept",
            key: "dept"
        },
        {
            title: "Location",
            dataIndex: "loc",
            key: "loc"
        },
        {
            title: "Verify",
            key: "verify",
            render: (text: any, record: any) => (
                <Button className="buttonverify" size="small">Verify</Button>
            )
        }
    ];



    if (subjects?.length > 0) {
        subjects.forEach((patientdata: any) => {
            const info = {
                name: patientdata.name ? patientdata.name : "",
                dob: patientdata.dob ? patientdata.dob : "",
                zipcode: patientdata.zipcode ? patientdata.zipcode : "",
                ssn: patientdata.ssn ? patientdata.ssn : "",
                id: patientdata?.id,
                key:patientdata?.id
            }
            patientmodaldata.push(info);
            sourcepatientmodaldata.push(info);
        })
    }

    column = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Date Of Birth",
            dataIndex: "dob",
            key: "dob"
        },
        {
            title: "Postal Code",
            dataIndex: "zipcode",
            key: "zipcode"
        },
        {
            title: "SSN",
            dataIndex: "ssn",
            key: "ssn"
        },
        {
            title: "Verify",
            key: "verify",
            render: (text: any, record: any) => (
                <Button className="buttonverify" size="small">Verify</Button>
            )
        }
    ];
    // Build the Source title with the required design
    const sourceStepTitle = (title: string, classname: string) => {
        let content = <Button className="stepbuttonorange">
            {title}
        </Button>;
    // check for the Source selected
        if (steps >= 1) {
            const selected = source?.selected;
            content = <Button className={classname}>
                <span className="buttontitle">{title} </span>
                <br />
                <span className="buttontext">{selected?.firstname} </span>
            </Button>;
        }
        return content;
    };

    // Build the Subject title with the required design
    const subjectStepTitle = (title: string, classname: string) => {
        let content = <Button className="stepbuttonorange">Verify Subject </Button>;
        // check for the patient selected
        if ((steps == 2 && (choosecaller.start || sbutton))) {
            const selected = patients?.selected;
            content = <Button className={classname}>
                <span className="buttontitle">{title} </span>
                <br />
                <span className="buttontext">{selected?.lastname} </span>
            </Button>;
        }
        return content;
    };

    // Build the Incoming Call title with the required design
    const callStepTitle= (title: string, classname: string) => {
        let formatphone = title;
        const content = <Button className={classname}>
            <>
                <img style={{ "padding": "7px" }}
                    src={resolver(phonevalidate)}
                    draggable="false"
                />
                {formatphone}
            </></Button>;
        return content;
    };

    // Verify the step and set status
    const statusCheck = (type: string) => {
        let status = "wait";
        if (type === "source") {
            if (steps >= 1) {
                status = "finish";
            }
        }
        if (type === "subject") {
            if (steps == 2) {
                status = "finish";
            }
        }
        return status;
    }


    // Build UI for the data to display
    let modalui = (
        <>

            <Tabs
                defaultActiveKey={tabs}
                activeKey={tabs}
                style={{ background: "#fff" }}
                className="ant-tabs--identifyflow"
                onChange={() => console.debug("tab clicked")}
                onTabClick={(event: any) => { setTabs(event) }}
                type="line"
                tabBarGutter={300}
                tabBarStyle={{ fontSize: '18px' }}
            >
                <TabPane
                    tab={
                        <span style={{ paddingLeft: "120px" }}>
                            Providers
                                <Badge count={sourcemodaldata?.length}></Badge>
                        </span>
                    }
                    key="1"
                    disabled={sourectab}
                >
                    <Table
                        columns={sourcecolumn}
                        dataSource={sourcemodaldata}
                        size="small"
                        onRow={(record:any,event: any) => {
                            return {
                                onClick: (event2:any) => {
                                    setStep(1);
                                    setSourceTab(true);
                                    setTabs("2");
                                    const selected = sourcedata?.find(
                                        (item: any) => item.id === record.id
                                    );
                                    dispatch(
                                        selectAction(selected?.id)
                                    )
                                }, // click row
                              };
                        }}
                        loading={skeleton?.source_skeleton}
                    />
                </TabPane>

                <TabPane tab={
                    <span>
                        Patients
                 <Badge count={steps===0?sourcepatientmodaldata.length:patientmodaldata?.length}></Badge>
                    </span>
                } key="2" >
                    <Table
                        columns={column}
                        dataSource={steps===0?sourcepatientmodaldata:patientmodaldata}
                        size="small"
                        onRow={(record:any,event: any) => {
                            return {
                             onClick: (event1:any) => {
                                    let selected = subjects.find(
                                        ((patient: any) => patient.id === record.id)
                                    );
                                    if (steps == 0) {
                                        setStep(1);
                                        setSourceTab(true);
                                        setTabs("2");
                                        if(!selected){
                                        selected = sourcepatientmodaldata?.find(
                                                (item: any) => item.id === record.id
                                            );
                                        }
                                        dispatch({
                                            type: "one-state-source/add",
                                            payload: selected
                                        });
                                        dispatch(
                                            selectAction(selected?.id)
                                        )
                                    }
                                    else {
                                        setStep(2);
                                        setMappingPage(true);
                                        dispatch(setSelectedAction(selected));
                                        //   dispatch(selectAction(event.id))
                                        let patientmodelskeleton: Skeleton = {
                                            upcomingAppts_skeleton: true,
                                            pendingReferrals_skeleton: true,
                                            pendingBills_skeleton: true,
                                            insurance_skeleton: true,
                                            pendingCare_skeleton: true,
                                            pharmacies_skeleton: true,
                                            source_skeleton: false,
                                            callingDestination_skeleton: false,
                                            subject_skeleton: false,
                                        }
                                        dispatch(setSkeletonAction(
                                            patientmodelskeleton
                                        ));
                                        // Make patient as verified after selection from patient modal menu
                                        dispatch({
                                            type: "one-state-patient-verified/set",
                                            payload: {
                                                verified: true,
                                            }
                                        });
                                        setSButton(true);
                                        // check for the source selected or not
                                        if(source?.selected){
                                            //
                                        } else {
                                            dispatch({
                                                type: "one-state-choosecaller/set",
                                                payload: {
                                                    number: choosecaller.number,
                                                    dnis: choosecaller.dnis,
                                                    visible: false
                                                }
                                            });
                                        }
                                    }
                             } //end row click
                            }
                        }}
                        loading={skeleton?.subject_skeleton}
                    />
                </TabPane>
            </Tabs>
            <br />
            <Row gutter={8}>
                <Col span={4}>
                    <Button id="providersearchverify" type="primary" size="small" htmlType="submit" className="buttonsfooter">
                        <img style={{ "padding": "1px" }}
                            src={resolver(SearchIco)}
                            width={15}
                            draggable="false"
                        />   {
                            tabs==="2"?"Search Patient":"Search Provider"
                        }</Button>
                </Col>
                <Col span={4}>
                    <Button id="providersearchverify" type="primary" size="small" htmlType="submit" className="buttonsfooter" >
                        {
                            tabs==="2"?"New Patient":"New Provider"
                        }
                    </Button>
                </Col>
                <Col span={16} push={12}>
                    <Button id="providersearchverify" type="primary" size="small" htmlType="submit" className="buttonsfooter" onClick={() => {
                        if (steps == 0) {
                            setStep(1);
                            setSourceTab(true);
                            setTabs("2");
                        } else{
                        dispatch({
                            type: "one-state-choosecaller/set",
                            payload: {
                                number: choosecaller.number,
                                dnis: choosecaller.dnis,
                                visible: false
                            }
                        });
                    }
                    }} >Skip</Button>
                </Col>
            </Row>
        </>
    )
    // Modify UI if both Source and Subject are selected.
    if (mappingpage) {
        const selected = source?.selected;
        const selectedPatient = patients?.selected;

        modalui = (
            <>
                <br />
                <br />
                <br />
                <Row gutter={[16, 16]} >
                    <Col span={8}>
                    </Col>
                    <Col span={16} >
                        <Values>
                            <Value
                                label='Source'
                                value={selected?.firstname}
                            />

                            <div className="values__value" >
                                <b>
                                    Relation:
                            </b>
                            &nbsp;is a &nbsp;
                             <Select style={{ width: 180 }} placeholder={"Type  Relation"}   onSelect={(value: string) => {
                               setRelation(value);
                            }} >
                                    <Option value={"Parent"} key={"Parent"}>Parent</Option>
                                    <Option value={"Family Member"} key={"fmember"}>Family Member</Option>
                                    <Option value={"Patient Care TakerrentCtaker"} key={"parentCtaker"}>Patient Care Taker</Option>
                                    <Option value={"Other Representative"} key={"other"}>Other Representative</Option>
                                </Select>
                            &nbsp;  &nbsp;  of
                        </div>
                            <Value
                                label='Subject'
                                value={selectedPatient?.lastname}
                            />
                        </Values>
                    </Col>
                    <Col span={8}>
                    </Col>
                </Row>
                <br />
                <br />
                <Row gutter={8}>
                    <Col span={4}>

                    </Col>

                    <Col span={16} push={12}>
                        <Button id="providersearchverify" type="primary" size="small" htmlType="submit" className="buttonsfooter" onClick={() => {
                            dispatch({
                                type: "one-state-choosecaller/set",
                                payload: {
                                    number: choosecaller.number,
                                    dnis: choosecaller.dnis,
                                    visible: false
                                }
                            });
                        }} >Skip</Button>

                    </Col>
                    <Col span={4}>
                        <Button type="primary" size="small" htmlType="submit" className="buttonsfooter"
                            onClick={() => {
                                let rel = relation;
                                if(relation === 'Type Relation'){
                                    rel = null;
                                }
                                dispatch({
                                    type: "one-state-choosecaller/set",
                                    payload: {
                                        number: choosecaller.number,
                                        dnis: choosecaller.dnis,
                                        visible: false,
                                        relation:rel
                                    }
                                });
                            }} >Complete</Button>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <div>
            <Modal
                visible={choosecaller?.visible}
                footer={null}
                centered
                width={870}
                closable={false}
                wrapClassName="custom-modal-wrap custom-choosepatient-wrap"
                destroyOnClose
            >
                <Steps current={2} progressDot={true}>
                    <Step status="finish" title={callStepTitle(choosecaller.number, "stepbuttongreen divrectangle")} />
                    <Step status={statusCheck("source")} title={sourceStepTitle("Source", "stepbuttongreen divrectangle")} />
                    <Step status={statusCheck("subject")} title={subjectStepTitle("Subject", "stepbuttongreen divrectangle")} />
                </Steps>
                {modalui}
            </Modal>
        </div>
    );
};
